import React from "react";
import Slider from "react-slick";

function LogoSlider() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          }
        },
    ]
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        <div>
          <div className="flex gap-[30px]">
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              /
            </p>
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              Risk Management
            </p>
            <div className="border border-[#00725d] p-[7px] h-[30px] w-[30px] rounded-full flex justify-center items-center">
              <div className="h-[16px] w-[16px] bg-[#00725d] rounded-full"></div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex gap-[30px]">
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              /
            </p>
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              Strategic Insights
            </p>
            <div className="border border-[#00725d] p-[7px] h-[30px] w-[30px] rounded-full flex justify-center items-center">
              <div className="h-[16px] w-[16px] bg-[#00725d] rounded-full"></div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex gap-[30px]">
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              /
            </p>
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              Customized Solutions
            </p>
            <div className="border border-[#00725d] p-[7px] h-[30px] w-[30px] rounded-full flex justify-center items-center">
              <div className="h-[16px] w-[16px] bg-[#00725d] rounded-full"></div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex gap-[30px]">
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              /
            </p>
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              Risk Management
            </p>
            <div className="border border-[#00725d] p-[7px] h-[30px] w-[30px] rounded-full flex justify-center items-center">
              <div className="h-[16px] w-[16px] bg-[#00725d] rounded-full"></div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex gap-[30px]">
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              /
            </p>
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              Strategic Insights
            </p>
            <div className="border border-[#00725d] p-[7px] h-[30px] w-[30px] rounded-full flex justify-center items-center">
              <div className="h-[16px] w-[16px] bg-[#00725d] rounded-full"></div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex gap-[30px]">
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              /
            </p>
            <p className="font-[500] md:text-[45px] text-[20px] md:leading-[52px] leading-[24px] uppercase text-[#00725d]">
              Customized Solutions
            </p>
            <div className="border border-[#00725d] p-[7px] h-[30px] w-[30px] rounded-full flex justify-center items-center">
              <div className="h-[16px] w-[16px] bg-[#00725d] rounded-full"></div>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  );
}

export default LogoSlider;
